import { gql } from "@apollo/client";

export const CREATE_BRAND = gql`
  mutation createVehicleBrand($data: CreateVehicleBrandInput!) {
    createVehicleBrand(data: $data) {
      id
      name
    }
  }
`;

export const UPDATE_BRAND = gql`
  mutation updateVehicleBrand($data: UpdateVehicleBrandInput!) {
    updateVehicleBrand(data: $data) {
      id
      name
    }
  }
`;

export default CREATE_BRAND;
